var React = require('react');

function Mood (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":" M 44.963 7.5 C 24.263 7.5 7.5 24.3 7.5 45 C 7.5 65.7 24.263 82.5 44.963 82.5 C 65.7 82.5 82.5 65.7 82.5 45 C 82.5 24.3 65.7 7.5 44.963 7.5 Z  M 45 75 C 28.425 75 15 61.575 15 45 C 15 28.425 28.425 15 45 15 C 61.575 15 75 28.425 75 45 C 75 61.575 61.575 75 45 75 Z  M 58.125 41.25 C 61.238 41.25 63.75 38.738 63.75 35.625 C 63.75 32.513 61.238 30 58.125 30 C 55.013 30 52.5 32.513 52.5 35.625 C 52.5 38.738 55.013 41.25 58.125 41.25 Z  M 31.875 41.25 C 34.988 41.25 37.5 38.738 37.5 35.625 C 37.5 32.513 34.988 30 31.875 30 C 28.763 30 26.25 32.513 26.25 35.625 C 26.25 38.738 28.763 41.25 31.875 41.25 Z  M 45 65.625 C 53.738 65.625 61.162 60.15 64.162 52.5 L 25.838 52.5 C 28.838 60.15 36.263 65.625 45 65.625 Z "}));
}

Mood.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"7.5 7.5 75 75","width":"75pt","height":"75pt"};

module.exports = Mood;

Mood.default = Mood;
